const products = {
  PrimaryCollection: {
    name: 'Fruminnheimta',
    value: 'PrimaryCollection',
    code: 'F',
    color: '#ABCFA5',
  },
  SecondaryCollection: {
    name: 'Milliinnheimta',
    value: 'SecondaryCollection',
    code: 'M',
    color: '#FCF0C8',
  },
  LegalCollection: {
    name: 'Upphaf löginnheimtu',
    value: 'LegalCollection',
    code: 'L',
    color: '#E47B35',
  },
  LegalCollection2: {
    name: 'Löginnheimta',
    value: 'LegalCollection2',
    code: 'L',
    color: '#88233A',
  },
  DebtSurveillance: {
    name: 'Kröfuvakt',
    value: 'DebtSurveillance',
    code: 'K',
    color: '#E8CAF7',
  },
  ForeignCollection: {
    name: 'Millilandainnheimta',
    value: 'ForeignCollection',
    code: 'E',
    color: '#FCF0C8',
  },
  CurrencyTurnover: {
    name: 'Myntvelta',
    value: 'CurrencyTurnover',
    code: 'My',
    color: '#64B5F6',
  },
};

export function getProducts() {
  return Object.values(products).filter((x) => {
    return x.value !== 'CurrencyTurnover' && x.value !== 'ForeignCollection';
  });
}

export default function getProduct(number) {
  return products[number];
}
